export default __webpack_public_path__ + "static/media/arrow-right.18aa13bd.svg";